export default "__VITE_ASSET__OMTPgncA__"